export function target() {
  return this.module === 'Social' && !this.data.titleColor;
}

export function migrate() {
  this.data.titleColor = this.data.textColor;
}
